import { Component, OnInit, ViewChild } from '@angular/core';
import { Venmaeparroquia } from '../veninterfaces/venmaeparroquia';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { VenmaeparroquiaService } from '../venservicios/venmaeparroquia.service';
import { ErroresBaseDatosService } from '../../servicios/errores-base-datos.service';
import { DatePipe } from '@angular/common';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'app-venmaeparroquia',
  templateUrl: './venmaeparroquia.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class VenmaeparroquiaComponent implements OnInit {

  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;

  indicador: any;
  permisoMaeparroquia: SegMaePermiso;
  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;

  public frameworkComponents;
  rowSelection = 'multiple';
  defaultCxcparroquia;
  rowStyle;
  largo: string;
  parroquiaSelected: Venmaeparroquia;
  index = 0;

  types: SelectItem[];
  busquedacampos: any[];
  tabla: string;
  consulta: string;
  arregloCons: any[];
  arregloBus: any[];
  condicion: string;
  opcionbusqueda: string;
  displayDialogBusquedaFast: boolean;
  displayDialogBusqueda: boolean;
  where: string

  columnDefsMaeparroquia = [
    {
      headerName: 'Código', field: 'PARR_CODIGO', editable: (params) => {
        return this.validaboolena(params)
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 10
        }
      }
    },
    {
      headerName: 'Nombre', field: 'PARR_DESCRIPCION', editable: (params) => {
        return true
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 100
        }
      }
    },
    {

      headerName: 'Parroquia', field: 'CAN_CODIGO', editable: (params) => {
        return this.validaboolena(params)
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 10,
          opcionbuscar: true
        }
      }
    },
  ];
  constructor(
    public venmaeparroquiaService: VenmaeparroquiaService, private confirmationService: ConfirmationService,
    private busquedaSer: InvbusquedaService, private permisosService: PermisosService,
    public init: NuevoComponentService, private datePipe: DatePipe, private messageService: MessageService, private auditoriagral: AuditoriagralService,
  ) {
    this.agTable()
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultCxcparroquia = {
      editable: true,
      objeto: 'maeparroquia',
      resizable: true
    };
  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;

    try {
      this.venmaeparroquiaService.detparroquia = []
      await this.getPermisos()
      const data = await this.venmaeparroquiaService.getmaeparroquia()
      if (data !== null) {
        for (const iterator of data) {
          iterator.NUEVO = false;
        }
        this.venmaeparroquiaService.detparroquia = data
        this.parroquiaSelected = this.venmaeparroquiaService.detparroquia[this.venmaeparroquiaService.detparroquia.length - 1]
      }
    } catch (error) {
      this.messageService.add({
        key: 'maeparroquia',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al cargar la información' + error
      });
    }
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoMaeparroquia = data[0];
        } else {
          this.permisoMaeparroquia = null;
        }
      } else {
        this.permisoMaeparroquia = null;
      }
    } catch (e) {
      this.permisoMaeparroquia = null;
      this.messageService.add({
        key: 'maeparroquia',
        severity: 'error',
        summary: 'Información',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  async manejarSenales(valor) {
    if (valor === 'Cancelar') {
      this.cancelar()
    }
    if (valor === 'Nuevo') {
      if (this.permisoMaeparroquia.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoMaeparroquia.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'maeparroquia',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada'
          });
        }
      }
    }
    if (valor === 'Guardar') {
      if (this.permisoMaeparroquia.PERTODO === 1) {
        this.validarGuardar();
      } else {
        if (this.permisoMaeparroquia.PERINSERCION === 1) {
          this.validarGuardar();
        } else {
          this.messageService.add({
            key: 'maeparroquia',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada'
          });
        }
      }
    }
    if (valor === 'Borrar') {
      if (this.permisoMaeparroquia.PERELIMACION === 1) {
        if (this.parroquiaSelected === undefined) {
          this.messageService.add({
            key: 'maeparroquia',
            severity: 'error',
            summary: 'Eliminación de la Parroquia',
            detail: ' Seleccion Incorrecta, no se ha selecionado una parroquia'
          });
        } else {
          this.confirmarElimnar();
        }
      } else if (this.permisoMaeparroquia.PERELIMACION === 0) {
        this.messageService.add({
          key: 'maeparroquia',
          severity: 'error',
          summary: 'Eliminación de la Parroquia',
          detail: 'El usuario no tiene permisos de Eliminacion, acción denegada'
        });
        this.parroquiaSelected.PARR_CODIGO = '';
        this.aggrid.refreshaggrid(this.venmaeparroquiaService.detparroquia, this.defaultCxcparroquia.objeto);
      }
    }
    if (valor === 'Buscar') {
      if (this.permisoMaeparroquia.PERTODO === 1) {
        this.busqueda();
      } else {
        if (this.permisoMaeparroquia.PERSELECCION === 1) {
          this.busqueda();
        } else {
          this.messageService.add({
            key: 'maeparroquia',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos para consultar, acción denegada'
          });
        }
      }
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  busqueda(){
    this.opcionbusqueda = 'BUSCARPARROQUIA';
    this.types = [
      {label: 'CÓDIGO', value: 'PARR_CODIGO'},
      {label: 'PARROQUIA', value: 'PARR_DESCRIPCION'},
      {label: 'CANTÓN NOMBRE', value: 'CAN_NOMBRE'},
      {label: 'CANTÓN COD.', value: 'CAN_CODIGO'},
      
    ];
    
    this.busquedacampos = ['', '', '',''];
    this.consulta = 'PARR_CODIGO,PARR_DESCRIPCION,VEN_FNC_NOMBRECANTON(CAN_CODIGO) AS CAN_NOMBRE,CAN_CODIGO';
    this.tabla = 'VEN_MAEPARROQUIA';
    this.condicion = ' PARR_CODIGO is not null order by 1 asc';
    this.arregloCons = [];
    this.displayDialogBusquedaFast = true;
  }
  manejarSeleccion(valor){
    if (this.opcionbusqueda === 'BUSCARPARROQUIA') {
      this.displayDialogBusquedaFast = false;
      this.venmaeparroquiaService.detparroquia = valor;
    }
  }
  confirmarElimnar() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar la parroquia seleccionada',
      header: 'Eliminar Parroquia',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmarparroquia',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.eliminarParroquia();
      },
      reject: () => {
      }
    });
  }
  async eliminarParroquia() {
    try {
      await this.venmaeparroquiaService.eliminarparroquia(this.parroquiaSelected);
      this.auditoriagral.registrarAuditoria('VEN_MAEPARROQUIA', String(this.parroquiaSelected.PARR_CODIGO), 'E',
        '', '01', '', '', '', '').subscribe(() => {
        });
      this.venmaeparroquiaService.detparroquia = this.venmaeparroquiaService.detparroquia.filter((val, j) => j !==
        this.venmaeparroquiaService.detparroquia.indexOf(this.parroquiaSelected));
      this.aggrid.refreshaggrid(this.venmaeparroquiaService.detparroquia, this.defaultCxcparroquia.objeto);
      await this.cancelar()
      this.messageService.add({
        key: 'maeparroquia',
        severity: 'success',
        summary: 'Información',
        detail: 'Éxito al eliminar la parroquia'
      })
    } catch (error) {
      this.messageService.add({
        key: 'maeparroquia',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al eliminar la parroquia' + error.error
      });
      return
    }
  }
  async validarGuardar() {
    if (this.parroquiaSelected.PARR_CODIGO === '') {
      this.messageService.add({
        key: 'maeparroquia',
        severity: 'error',
        summary: 'Información',
        detail: 'El código de la parroquia no puede estar vacío'
      });
      return
    }
    if (this.parroquiaSelected.PARR_DESCRIPCION === '') {
      this.messageService.add({
        key: 'maeparroquia',
        severity: 'error',
        summary: 'Información',
        detail: 'El nombre de la parroquia no puede estar vacío'
      });
      return
    }
    if (this.parroquiaSelected.CAN_CODIGO === '') {
      this.messageService.add({
        key: 'maeparroquia',
        severity: 'error',
        summary: 'Información',
        detail: 'El cantón  no puede estar vacío'
      });
      return
    }
    await this.finguardar()
  }
  async finguardar() {
    try {
      if (this.parroquiaSelected.NUEVO === true) {
        await this.venmaeparroquiaService.insertarparroquia(this.parroquiaSelected);
        this.auditoriagral.registrarAuditoria('VEN_MAEPARROQUIA', String(this.parroquiaSelected.PARR_CODIGO), 'I',
          '', '01', '', '', '', '').subscribe(() => {
          });
        this.messageService.add({
          key: 'maeparroquia',
          severity: 'success',
          summary: 'Información',
          detail: 'Éxito al guardar la parroquia'
        });
        await this.cancelar()
      } else if (this.parroquiaSelected.NUEVO === false) {
        await this.venmaeparroquiaService.actualizarparroquia(this.parroquiaSelected)
        this.auditoriagral.registrarAuditoria('VEN_MAEPARROQUIA', String(this.parroquiaSelected.PARR_CODIGO), 'A',
          '', '01', '', '', '', '').subscribe(() => {
          });
        this.messageService.add({
          key: 'maeparroquia',
          severity: 'success',
          summary: 'Información',
          detail: 'Éxito al actualizar la parroquia'
        })
        await this.cancelar()
      }
    } catch (error) {
      this.messageService.add({
        key: 'maeparroquia',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un erro al guardar la parroquia' + error.error
      });
      return
    }
  }
  nuevo() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    const index = this.venmaeparroquiaService.detparroquia.findIndex(cuenta => cuenta.PARR_CODIGO === this.parroquiaSelected.PARR_CODIGO);

    this.parroquiaSelected = {
      CAN_CODIGO: '',
      COM_CODIGO: '01',
      PARR_CODIGO: '',
      PARR_DESCRIPCION: '',
      NUEVO: true
    }
    if (index == -1) {
      this.venmaeparroquiaService.detparroquia.push(this.parroquiaSelected);
      this.aggrid.refreshaggrid(this.venmaeparroquiaService.detparroquia, this.defaultCxcparroquia.objeto);
    } else {
      this.venmaeparroquiaService.detparroquia.splice(index + 1, 0, this.parroquiaSelected)
      this.parroquiaSelected = this.parroquiaSelected;
      this.aggrid.refreshaggridindex(this.venmaeparroquiaService.detparroquia, this.defaultCxcparroquia.objeto, index);
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
        this.defaultCxcparroquia.objeto].setFocusedCell(index + 1, 'PARR_CODIGO');
    }


  }
  validaboolena(params) {
    if (params.data.NUEVO === true) {
      return true
    } else {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = true;
      this.botonRegresar = false;
      return false
    }
  }
  async cancelar() {
    try {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;

      this.venmaeparroquiaService.detparroquia = []
      const data = await this.venmaeparroquiaService.getmaeparroquia()
      if (data !== null) {
        for (const iterator of data) {
          iterator.NUEVO = false;
        }
        this.venmaeparroquiaService.detparroquia = data
      }
    } catch (error) {
      this.messageService.add({
        key: 'maeparroquia',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al cargar la información' + error
      });
    }
  }
  changeTabs() {

  }
  seleccionItem(params) {

  }
  cambio(params) {

  }
}
